
import React from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Progress } from '@/components/ui/progress'
import { Upload } from 'lucide-react'

interface UploadFormProps {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleUpload: () => void
  file: File | null
  uploading: boolean
  progress: number
}

const UploadForm = ({ handleFileChange, handleUpload, file, uploading, progress }: UploadFormProps) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          className="flex-grow"
          disabled={uploading}
        />
        <Button 
          onClick={handleUpload} 
          disabled={!file || uploading}
          className="flex items-center gap-2"
        >
          {uploading ? 'Processing...' : 'Upload'}
          {!uploading && <Upload className="h-4 w-4" />}
        </Button>
      </div>

      {uploading && (
        <Progress value={progress} className="w-full" />
      )}
    </div>
  )
}

export default UploadForm
